import * as THREE from "three";

export const createMoonTexture = (size = 512) => {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#d8d0c0";
  ctx.fillRect(0, 0, size, size);

  for (let i = 0; i < 6000; i++) {
    const x = Math.random() * size;
    const y = Math.random() * size;
    const shade = 150 + Math.random() * 70;
    ctx.fillStyle = `rgba(${shade},${shade - 8},${shade - 22},0.12)`;
    ctx.beginPath();
    ctx.arc(x, y, Math.random() * 1.4, 0, Math.PI * 2);
    ctx.fill();
  }

  const craterCount = 55;
  for (let i = 0; i < craterCount; i++) {
    const x = Math.random() * size;
    const y = Math.random() * size;
    const r = 5 + Math.random() * Math.random() * 65;
    const grad = ctx.createRadialGradient(x - r * 0.3, y - r * 0.3, r * 0.1, x, y, r);
    grad.addColorStop(0, "rgba(110,102,92,0.55)");
    grad.addColorStop(0.7, "rgba(90,84,76,0.32)");
    grad.addColorStop(1, "rgba(90,84,76,0)");
    ctx.fillStyle = grad;
    ctx.beginPath();
    ctx.arc(x, y, r, 0, Math.PI * 2);
    ctx.fill();

    ctx.strokeStyle = "rgba(230,224,210,0.22)";
    ctx.lineWidth = Math.max(1, r * 0.05);
    ctx.beginPath();
    ctx.arc(x, y, r * 0.96, 0, Math.PI * 2);
    ctx.stroke();
  }

  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.needsUpdate = true;
  return texture;
};

export const createGlowTexture = (size = 256, color = "232,194,122") => {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  const grad = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
  grad.addColorStop(0, `rgba(${color},0.55)`);
  grad.addColorStop(0.4, `rgba(${color},0.22)`);
  grad.addColorStop(1, `rgba(${color},0)`);
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, size, size);
  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  return texture;
};

export const createFlareTexture = (size = 128) => {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  const c = size / 2;
  const grad = ctx.createRadialGradient(c, c, 0, c, c, c);
  grad.addColorStop(0, "rgba(255,255,255,0.9)");
  grad.addColorStop(0.35, "rgba(255,255,255,0.25)");
  grad.addColorStop(1, "rgba(255,255,255,0)");
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, size, size);
  ctx.strokeStyle = "rgba(255,255,255,0.35)";
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.moveTo(0, c);
  ctx.lineTo(size, c);
  ctx.moveTo(c, 0);
  ctx.lineTo(c, size);
  ctx.stroke();
  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  return texture;
};

export const createNebulaTexture = (size = 512) => {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  const blobs = [
    { x: 0.35, y: 0.45, r: 0.35, color: "99,80,200" },
    { x: 0.65, y: 0.55, r: 0.3, color: "60,90,180" },
    { x: 0.5, y: 0.5, r: 0.45, color: "120,90,210" },
  ];
  blobs.forEach((b) => {
    const grad = ctx.createRadialGradient(b.x * size, b.y * size, 0, b.x * size, b.y * size, b.r * size);
    grad.addColorStop(0, `rgba(${b.color},0.35)`);
    grad.addColorStop(1, `rgba(${b.color},0)`);
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, size, size);
  });
  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  return texture;
};

export const createTrailTexture = () => {
  const canvas = document.createElement("canvas");
  canvas.width = 128;
  canvas.height = 8;
  const ctx = canvas.getContext("2d");
  const grad = ctx.createLinearGradient(0, 0, 128, 0);
  grad.addColorStop(0, "rgba(255,255,255,0)");
  grad.addColorStop(0.6, "rgba(255,255,255,0.65)");
  grad.addColorStop(1, "rgba(255,255,255,0.95)");
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, 128, 8);
  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  return texture;
};
